const WorkExperience = [
    {
        id: 0,
        title: "Full-Stack Engineer",
        company: "OneGreenDiary",
        yearsActive: "August 2022 - Present",
        information: [
            "Restructured Point-of-Sale (POS) system to improve its existing features and data management.",
            "Implemented Firebase Cloud Messaging within Angular and Electron applications.",
            "Allowed users to use POS functionalities for extended periods of time, even when offline, by handling better offline capabilities.",
        ],
    },
    {
        id: 1,
        title: "Full-Stack Engineer",
        company: "Outverse",
        yearsActive: "April 2021 - May 2022",
        information: [
            "Managed role assignments to ensure appropriate user access to specific channels and privileges.",
            "Collaborated with team of developers to develop and implement efficient, flexible and reusable user interface components.",
            "Worked with backend engineers to optimize existing API calls to create efficiencies by deprecating unneeded API calls.",
        ],
    },
    {
        id: 2,
        title: "Front-End Engineer",
        company: "VisibleOne",
        yearsActive: "November 2017 - December 2020",
        information: [
            "Designed, developed and modified 30+ software systems and custom components.",
            "Worked with a team of developers, to add features, fix bugs and making upgrades to their existing websites and apps.",
            "Developed and executed test procedures for user interfaces, back-end processing, connectivity, and relational database interactions.",
            "Analyzed systems flow, data usage, and work processes.",
            "Used RESTful APIs to connect and link Guest services to other API endpoints like membership and Registry"
        ],
    },
    {
        id: 3,
        title: "Education",
        company: "Singapore University of Technology and Design (SUTD)",
        yearsActive: "April 2013 - September 2017",
        information: [
            "Finished my Bachelor's Degree in computer science",
            "Got prize in ACM which is the part of International Collegiate Programming Contest"
        ],
    },
];

export default WorkExperience;
